import React from 'react';
import { IconSvgProps } from '@models/common';

const DocumentSparkle: React.FC<IconSvgProps> = (props) => {
  const { size = 24, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 25 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M5.52563 18.9996V5.0004C5.52563 4.59949 5.67153 4.39619 5.82094 4.27384C6.00384 4.12411 6.25614 4.05003 6.45493 4.05001H17.6756C18.2003 4.05001 18.626 4.47573 18.626 5.0004V11.8432C18.626 12.4231 19.0961 12.8932 19.676 12.8932C20.2559 12.8932 20.726 12.4231 20.726 11.8432V5.0004C20.726 3.31593 19.3601 1.95001 17.6756 1.95001H6.45493C5.8282 1.95003 5.091 2.15821 4.49086 2.64962C3.85718 3.16852 3.42563 3.9663 3.42563 5.0004V18.9996C3.42563 20.6841 4.79155 22.05 6.47602 22.05H9.87563C10.4555 22.05 10.9256 21.5799 10.9256 21C10.9256 20.4201 10.4555 19.95 9.87563 19.95H6.47602C5.95135 19.95 5.52563 19.5243 5.52563 18.9996Z'
        fill='currentColor'
      />
      <path
        d='M8.46909 8.85243C7.88919 8.85243 7.41909 8.38233 7.41909 7.80243C7.41909 7.22253 7.88919 6.75243 8.46909 6.75243H15.3726C15.9525 6.75243 16.4226 7.22253 16.4226 7.80243C16.4226 8.38233 15.9525 8.85243 15.3726 8.85243H8.46909Z'
        fill='currentColor'
      />
      <path
        d='M8.46879 13.05C7.88915 13.0497 7.41879 12.5797 7.41879 12C7.41879 11.4203 7.88915 10.9503 8.46879 10.95H11.9211C12.501 10.95 12.9711 11.4201 12.9711 12C12.9711 12.5799 12.501 13.05 11.9211 13.05H8.46879Z'
        fill='currentColor'
      />
      <path
        d='M16.2714 13.7597C16.3777 13.4725 16.7843 13.4725 16.8906 13.7597L17.9548 16.6357C17.9712 16.6803 17.9972 16.7208 18.0308 16.7545C18.0644 16.7882 18.1049 16.8142 18.1495 16.8307L21.0258 17.8949C21.3129 18.0012 21.3129 18.4078 21.0258 18.5141L18.1498 19.5783C18.1052 19.5948 18.0647 19.6207 18.031 19.6543C17.9973 19.6879 17.9713 19.7284 17.9548 19.773L16.8906 22.649C16.7843 22.9365 16.3777 22.9365 16.2714 22.649L15.2072 19.7734C15.1907 19.7287 15.1648 19.6882 15.1312 19.6545C15.0976 19.6209 15.0571 19.5948 15.0125 19.5783L12.1362 18.5141C11.8491 18.4078 11.8491 18.0012 12.1362 17.8949L15.0121 16.8307C15.0568 16.8142 15.0973 16.7883 15.131 16.7547C15.1647 16.7211 15.1907 16.6806 15.2072 16.636L16.2714 13.7597Z'
        fill='currentColor'
      />
    </svg>
  );
};

export default DocumentSparkle;
